





// import * as React from "react";
// import Section1 from "../components/Section1";
// import Footer from "../components/Footer";
// import Testimonials from "../components/Testimonials";
// import BlogPosts from "../components/BlogPosts";
// import Stats from "../components/Stats";

// function Dashboard() {
  
//   return (
//     <>
//     <div className="relative w-full">
//   {/* Masaüstü Banner */}
//   <div className="hidden md:block w-full h-[850px]">
//     <img
//       src="/images/pcbanner6.png"
//       alt="PC Banner"
//       className="w-full h-full object-cover"
//     />
//   </div>
// {/* Mobil Banner */}
// <div className="block md:hidden w-full">
//   <img
//     src="/images/mobilbanner8.webp"
//     alt="Mobil Banner"
//     className="w-full h-auto "
//   />
// </div>

// </div>


// {/* ALT KISIM BURADA, YUKARI KAYMAMASI İÇİN BOŞLUK VERİLDİ */}
// <div className="relative z-10 ">
// {/* <div className="relative z-10 mt-[750px] md:mt-[400px] lg:mt-[750px]"> */}
//   <Section1 />
//   <Testimonials />
//   <BlogPosts />
//   <Stats />
//   <Footer />
// </div>

//     </>
//   );
// }

// export default Dashboard;
import * as React from "react";
import Section1 from "../components/Section1";
import Footer from "../components/Footer";
import Testimonials from "../components/Testimonials";
import BlogPosts from "../components/BlogPosts";
import Stats from "../components/Stats";

function Dashboard() {
  return (
    <>
      {/* GENEL WRAPPER */}
      <div className="px-[2px] bg-white">
        
        {/* Banner Alanı */}
        <div className="relative w-full overflow-hidden rounded-sm">
          
          {/* Masaüstü Banner */}
          <div className="hidden md:block w-full h-[850px]">
            <img
              src="/images/pcbanner6.png"
              alt="PC Banner"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Mobil Banner */}
          <div className="block md:hidden w-full h-screen">
            <img
              src="/images/mobilbanner8.webp"
              alt="Mobil Banner"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* ALT KISIM */}
        <div className="relative z-10">
          <Section1 />
          <Testimonials />
          <BlogPosts />
          <Stats />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Dashboard;